module.exports = __webpack_public_path__ + "img/auth-offline.7f233d3c.gif";